import React, { Component } from 'react';
import { Collapse, Container, Navbar, NavbarBrand, NavbarToggler, NavItem, NavLink, Button } from 'reactstrap';
import { Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import './NavMenu.css';

// Wrapper component to use hooks in class component
const NavMenuWithAuth = (props) => {
  const auth = useAuth();
  return <NavMenu {...props} auth={auth} />;
};


class NavMenu extends Component {
  static displayName = NavMenu.name;

  constructor (props) {
    super(props);

    this.toggleNavbar = this.toggleNavbar.bind(this);
    this.state = {
      collapsed: true
    };
  }

  toggleNavbar () {
    this.setState({
      collapsed: !this.state.collapsed
    });
  }

  render () {
    return (
      <header>
        <Navbar className="navbar-expand-sm navbar-toggleable-sm ng-white border-bottom box-shadow mb-3" light>
          <Container>
            <NavbarBrand tag={Link} to="/">CostCalculator</NavbarBrand>
            <NavbarToggler onClick={this.toggleNavbar} className="mr-2" />
            <Collapse className="d-sm-inline-flex flex-sm-row-reverse" isOpen={!this.state.collapsed} navbar>
              <ul className="navbar-nav flex-grow">
                {!this.props.auth.isAuthenticated() && (
                  <NavItem>
                    <NavLink tag={Link} className="text-dark" to="/login">Войти</NavLink>
                  </NavItem>
                )}
                {this.props.auth.isAuthenticated() && (
                  <>
                    <NavItem>
                      <NavLink tag={Link} className="text-dark" to="/">🏠 Главная</NavLink>
                    </NavItem>
                    {this.props.auth.isAdmin() && (
                      <NavItem>
                        <NavLink tag={Link} className="text-dark" to="/users">👤 Пользователи</NavLink>
                      </NavItem>
                    )}
                    {(this.props.auth.isAdmin() || this.props.auth.isManager()) && (
                      <>
                        <NavItem>
                          <NavLink tag={Link} className="text-dark" to="/work-categories">📁 Виды работ</NavLink>
                        </NavItem>
                        <NavItem>
                          <NavLink tag={Link} className="text-dark" to="/employees">👥 Сотрудники</NavLink>
                        </NavItem>
                        <NavItem>
                          <NavLink tag={Link} className="text-dark" to="/work-acts">📋 Акты работ</NavLink>
                        </NavItem>
                      </>
                    )}
                    <NavItem>
                      <Button
                        color="outline-secondary"
                        size="sm"
                        onClick={() => {
                          this.props.auth.logout();
                          window.location.href = '/';
                        }}
                      >
                        Выйти
                      </Button>
                    </NavItem>
                  </>
                )}
              </ul>
            </Collapse>
          </Container>
        </Navbar>
      </header>
    );
  }
}

// Export the wrapper component instead of the class component
export { NavMenuWithAuth as NavMenu };
